import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://ouilhiwgkuquwdclsqao.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im91aWxoaXdna3VxdXdkY2xzcWFvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU5OTkwNzAsImV4cCI6MjA5MTU3NTA3MH0.Pj8l5lo06ewNjObH2ycslLG6LdDzltZTb_5uRGqiI_U';

export const supabase = createClient(supabaseUrl, supabaseKey);